// SEROTA Yönetim adresleri Türkçe (2026-10-14 ürün kararı). Eski İngilizce adresler (yer imleri, paylaşılmış bağlantılar,
// ör. `/firmalar/:id`, `/platform/live`, `/audit-logs`) Türkçe karşılığına çevrilir; App bilinmeyen her adreste önce
// buna bakar. Saf fonksiyon (birim testli): yalnız yol çevrilir, arama ve # parçasını çağıran korur.

/** Yol parçası sözlüğü: eski İngilizce → Türkçe (kimlikler sözlükte olmadığı için değişmez). */
export const SEGMENTS = new Map<string, string>([
  ['login', 'giris'],
  ['companies', 'firmalar'],
  ['subscriptions', 'abonelikler'],
  ['plans', 'planlar'],
  ['feature-flags', 'moduller'],
  ['white-label', 'beyaz-etiket'],
  ['platform', 'platform'],
  ['live', 'canli'],
  ['gps-health', 'gps-sagligi'],
  ['usage', 'kullanim'],
  ['costs', 'maliyetler'],
  ['support', 'destek'],
  ['security', 'guvenlik'],
  ['impersonation', 'firma-olarak-giris'],
  ['privacy', 'gizlilik'],
  ['audit-logs', 'denetim-kaydi'],
  ['app-versions', 'uygulama-surumleri'],
  ['notification-templates', 'bildirim-sablonlari'],
  ['system', 'sistem'],
]);

/** Eski İngilizce yolu Türkçe yola çevirir; eski bir yönetim yolu değilse (veya zaten Türkçeyse) null döner. */
export function translateLegacyPath(pathname: string): string | null {
  const [, top = '', ...rest] = pathname.split('/');
  if (!SEGMENTS.has(top)) return null;
  const out = ['', top, ...rest].map((s) => SEGMENTS.get(s) ?? s).join('/');
  return out === pathname ? null : out;
}
